'use client'

import MarketingShell from '@/components/marketing/MarketingShell'

export default function AboutPage() {
  return (
    <MarketingShell>
      <section style={{ marginTop: 18, borderRadius: 22, border: '1px solid var(--border)', background: 'var(--panel)', padding: 22 }}>
        <h1 style={{ margin: 0, fontSize: 46, letterSpacing: '-0.04em', lineHeight: 1.05 }}>About DuoElevate</h1>
        <p style={{ marginTop: 12, color: 'var(--muted)', lineHeight: 1.7, maxWidth: 860 }}>
          DuoElevate is a career optimization platform focused on helping job seekers build better resumes, understand ATS matching, and
          apply with confidence.
        </p>

        <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          {[
            {
              title: 'What we build',
              desc: 'Resume creation and optimization, ATS analytics, and workflow tools that reduce time-to-apply without sacrificing quality.'
            },
            {
              title: 'How we think',
              desc: 'Security-first from day one. Minimal data retention. Encrypted resume storage. Clear boundaries between public help and authenticated actions.'
            },
            {
              title: 'Assistant philosophy',
              desc: 'The Assistant is a technician: guidance and troubleshooting are available for everyone; account-specific and privileged actions require login.'
            },
            {
              title: 'Built by Duoinfotech',
              desc: 'DuoElevate is developed as part of the Duoinfotech group.'
            }
          ].map((x, i) => (
            <div key={i} style={{ borderRadius: 18, border: '1px solid var(--border)', background: 'var(--bg)', padding: 14 }}>
              <div style={{ fontWeight: 1000, fontSize: 16 }}>{x.title}</div>
              <div style={{ marginTop: 8, color: 'var(--muted)', lineHeight: 1.7 }}>{x.desc}</div>
            </div>
          ))}
        </div>

        <style jsx>{`
          @media (max-width: 980px) {
            div[style*='grid-template-columns: 1fr 1fr'] {
              grid-template-columns: 1fr !important;
            }
            h1 {
              font-size: 38px !important;
            }
          }
        `}</style>
      </section>
    </MarketingShell>
  )
}
